import React from 'react';
import App from './App';

export const AppWrapper = (): JSX.Element => {
  return (
      <App />
  );
};

export default AppWrapper;
